export default {
    components: {

    },
    filters: {
    },
    data() {
        return {}
    },
    computed: {
    },
    watch: {

    },
    created() {

    },
    methods: {
        /**
        * @description 將map的values整併
        */
        mergedArray() {
            try {
                const mergedArray = Array.from(this.handleSelected.values()).reduce((accumulator, currentValue) => {
                    return accumulator.concat(currentValue.map(item => item.id));
                }, []);
                return mergedArray
            } catch (error) {
                console.error(error.message)
            }
        },
        /**
         * @description 改變頁數要重新打api && 並且要把勾選的資料放入handleSelected
         * @param {*} ovl 舊頁數
         * @param {*} selectedMember 選到的資料
         * @param {*} todoFunc 重新searchList的func
         */
        async changePage(ovl, selectedMember, todoFunc) {
            if (typeof (ovl) === 'number') {
                this.handleSelected.set(ovl, selectedMember)
            }
            await todoFunc()
        },
        /**
         * @description 回復使用者選的資料
         * @param {@} currentPage 現在這頁
         * @param {*} loadedData 現在table的Data
         * @param {*} table 要還原的table
         */
        reductionSelected(currentPage, loadedData, table) {
            if (this.handleSelected.has(currentPage)) {
                this.$nextTick(() => {
                    let result = []
                    this.handleSelected.get(currentPage).forEach(selectedItem => {
                        const oriItem = loadedData.find(tableItem => tableItem.id === selectedItem.id)
                        if (oriItem) {
                            result.push(oriItem)
                        }
                    })
                    this.toggleSelection(result, table)
                })
            }
        },
        /**
         * @description 切換 selected or not
         */
        toggleSelection(rows, table) {
            if (rows) {
                rows.forEach(row => {
                    table.toggleRowSelection(row);
                });
            } else {
                table.clearSelection();
            }
        },
        /**
     * @description 模仿time.sleep函數：功用：將程式暫停
     */
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        /**
     * @description 因為要批次發送，所以設定為100個一組
     * @param {} mergedArray 
     */
        splitMergeArray(mergedArray) {
            try {
                const groupedArray = mergedArray.reduce((acc, curr, index) => {
                    // 100 筆為一個單位
                    const groupIndex = Math.floor(index / 100);
                    if (!acc[groupIndex]) {
                        acc[groupIndex] = [];
                    }
                    acc[groupIndex].push(curr);
                    return acc;
                }, []);
                return groupedArray
            } catch (error) {
                console.error(error.message)
            }

        },
    }
}